
import { Component, Vue } from 'vue-property-decorator'

import UIkit from 'uikit'

import BacHeader from '@/templates/BacHeader.vue'
import { Http } from '@/lib/utils/Http'

@Component({
  components: {
    BacHeader
  }
})
export default class ResetPassword extends Vue {
  password = ''
  passwordConfirmation = ''

  successfullySent = false

  async send () {
    let error = ''
    if (this.password.length < 8) {
      error = 'Bitte wähle ein Passwort mit mehr als 8 Zeichen!'
    }
    if (this.password !== this.passwordConfirmation) {
      error = 'Passwort stimmt nicht mit Passwort Kontrolle überein!'
    }

    if (error) {
      UIkit.notification({
        message: error,
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      return
    }
    const res = await Http.request('/api/user/reset-password', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        hashId: this.$route.query.hashid,
        hash: this.$route.query.hash,
        password: this.password
      })
    })
    if (res.status !== 200) {
      UIkit.notification({
        message: 'Dieser Link ist nicht mehr gültig! Lass dir einen neuen Link zuschicken oder kontaktiere uns unter hello@backroadclub.com',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      return
    }
    this.successfullySent = true
  }
}
